"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _each2 = _interopRequireDefault(require("lodash/each"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ValidationUtil = _interopRequireDefault(require("../../../utils/v2/ValidationUtil"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Form Component
 */
var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _this.handleChange = function (id, value) {
      var values = _objectSpread({}, _this.state.values);

      values[id] = value;

      _this.setState({
        values: values
      });
    };

    _this.handleValidation = function (id, value) {
      var validations = _this.props.validations;

      var values = _objectSpread({}, _this.state.values);

      values[id] = value;

      var errors = _objectSpread({}, _this.state.errors);

      if (validations[id]) {
        errors[id] = _this._validateItem(validations[id], value);
      }

      _this.setState({
        values: values,
        errors: errors
      });
    };

    _this.handleReset = function () {
      _this.setState(_this.initialState);
    };

    _this.handleSubmit = function () {
      var _this$props = _this.props,
          validations = _this$props.validations,
          onSubmit = _this$props.onSubmit;

      var errors = _objectSpread({}, _this.state.errors);

      var values = _this.state.values;
      var hasError = false;
      (0, _each2.default)(validations, function (validation, id) {
        errors[id] = _this._validateItem(validation, values[id]);

        if (errors[id].error) {
          hasError = true;
        }
      });

      _this.setState({
        errors: errors
      }, function () {
        if (!hasError) {
          onSubmit(_objectSpread({}, _this.state.values));
        }
      });
    };

    _this.initialState = {
      values: props.defaultValues || {},
      errors: props.defaultErrors || {}
    };
    _this.state = _objectSpread({}, _this.initialState);
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          defaultValues = _this$props2.defaultValues,
          defaultErrors = _this$props2.defaultErrors,
          props = _objectWithoutProperties(_this$props2, ["className", "children", "defaultValues", "defaultErrors"]);

      var formBody;

      if (typeof children === 'function') {
        formBody = children({
          handleChange: this.handleChange,
          handleReset: this.handleReset,
          handleSubmit: this.handleSubmit,
          handleValidation: this.handleValidation,
          values: this.state.values,
          errors: this.state.errors,
          hasError: this.hasError()
        });
      } else {
        formBody = children;
      }

      return _react.default.createElement("form", _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-form"))
      }, props), formBody);
    }
    /**
     * Checks if there is an error in errors state
     * @returns {boolean} - Whether or not there is an error
     */

  }, {
    key: "hasError",
    value: function hasError() {
      var error = false;
      (0, _each2.default)(this.state.errors, function (errorObj) {
        if (errorObj.error) {
          error = true;
          return false;
        }
      });
      return error;
    }
    /**
     * Handler for form item changes
     * @param {string} id - Form item id
     * @param {string} value - Form item value
     */

  }, {
    key: "_validateItem",

    /**
     * Helper function that validates and populates errors object
     * @param {Object} validationRule - Validation rule
     * @param {string} value - Value to validate
     * @returns {Object} - Error object
     * @private
     */
    value: function _validateItem(validationRule, value) {
      var errorObj = {
        error: false
      };
      (0, _each2.default)(validationRule, function (ruleArg, rule) {
        var isValid = _ValidationUtil.default.validate(value, rule, ruleArg);

        if (!isValid) {
          errorObj.error = true;
          errorObj.message = validationRule.message;
          return false;
        }
      });
      return errorObj;
    }
  }]);

  return Form;
}(_react.default.Component);

exports.default = Form;
Form.VALIDATION_RULE = _ValidationUtil.default.RULE;
Form.VALIDATION_TYPE = _ValidationUtil.default.TYPE;
Form.propTypes = {
  /**
   * Items (child nodes).
   */
  children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),

  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Default values used by form
   */
  defaultValues: _propTypes.default.object,

  /**
   * Default errors used by form
   */
  defaultErrors: _propTypes.default.object,

  /**
   * Function to execute when form is ready to submit
   */
  onSubmit: _propTypes.default.func,

  /**
   * Defines what validations should be done for form items based on ids
   */
  validations: _propTypes.default.object
};